
/* injects from baggage-loader */

'use strict';

export default class AccountController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {

	}

}



// WEBPACK FOOTER //
// ./src/app/pages/account/account.controller.js